import { __assign } from "tslib";
import { UserSelect } from './User';
export var LocationInclude = {
    organization: true,
    businessUnit: true,
    responsible: {
        select: UserSelect,
    },
};
export var LocationOverviewInclude = __assign(__assign({}, LocationInclude), { logs: {
        where: { deleted: false },
        include: {
            organizationEmissions: { where: { deletedAt: null } },
        },
    } });
export var LocationSelectShallow = {
    id: true,
    name: true,
    address: true,
    businessUnit: { select: { id: true, title: true, key: true, ancestorIds: true, active: true } },
    active: true,
    metadata: true,
    geolocation: true,
    responsible: {
        select: { id: true, email: true, firstName: true, lastName: true, photo: true },
    },
};
//# sourceMappingURL=Location.js.map